import { makeDocumentAPIs } from '../../modules/documentAPIFactory'
import { getCaseDocumentListData } from './mockData'
import type { ICaseDocument } from '~/types/document/models'

export const {
  getDocuments: getCaseDocuments,
  postDocument: postCaseDocument,
  patchDocument: patchCaseDocument,
  deleteDocument: deleteCaseDocument,
  handlers,
} = makeDocumentAPIs<ICaseDocument>({
  apiPathEntityNamePrefix: 'case',
  getDocumentListDataFn: getCaseDocumentListData,
})
